
import fire from '../Firebase/fire';
import emailjs from "emailjs-com";
// import emailjs from '@emailjs/browser';
import {
    handle_Authenticate,
    handle_auth_user,
    // handle_mediaRecorder,
    handle_product_details,
    handle_Clear_Cart,
    handle_endDate,
    handle_billNumber,
    handle_subscriptions,
    handle_3DRecords
} from "./reducer"

export const authListener = () => {
    return async (dispatch) => {
      fire
      .auth()
      .onAuthStateChanged((user) => {
        if (user) {
          const authenticatedUser = {
            email: user.email,
            name: user.displayName,
            uid: user.uid,
          };
          // console.log("Redux:actions:authListener:true,authenticatedUser",authenticatedUser)
          console.log("authListener:true")
          dispatch(handle_Authenticate(true));
          dispatch(getAuthUser(user.email, authenticatedUser));
          dispatch(getSubscriptionDetails(user.email))
          dispatch(getCartDetails(user.email))
        } else {
          // console.log("Redux:actions:authListener:false")
          console.log("authListener:false")
          dispatch(handle_Authenticate(false));
          dispatch(handle_auth_user({}))
          dispatch(handle_subscriptions({}))
        }
      });
    };
  };

export const handleSignUp = (user) => {
    // console.log("Redux:actions:handleSignUp:loggedInUser:data incoming = ",user);
    return async (dispatch) => {
      fire
        .auth()
        .createUserWithEmailAndPassword(user.email, user.password)
        .then((userCredentials) => {
          if (userCredentials.user) {
            userCredentials.user
            .updateProfile({
              displayName: user.userName,
            })
            .then(() => {
              const loggedInUser = { email: user.email, name: user.userName };
              // console.log("Redux:actions:handleSignUp:loggedInUser = ",loggedInUser);
              console.log("handleSignUp:successful");
              dispatch(authListener());
              // authListener()
            });
          }
        })
        .catch((err) => {
            // console.log("Redux:actions:handleSignUp:err = ",err.cod);
            console.log("handleSignUp:err = ",err.cod);
            alert("User already exists! or the endered User credentials are not proper");
        })
    }
  };

export  const handleLogin = (user) => {
    // console.log("Redux:actions:handleLogin:loggedInUser:data incoming = ",user);
    return async (dispatch) => {
      fire
      .auth()
      .signInWithEmailAndPassword(user.email, user.password)
      .then((value) => {
        const loggedInUser = { email: user.email, name: user.name };
        // console.log("Redux:actions:handleLogin:success:loggedInUser = ",loggedInUser);
        console.log("handleLogin:successful");
        dispatch(authListener());
        // authListener()
      })
      .catch((err) => {
        // console.log("Redux:actions:handleLogin:err = ",err.cod);
        console.log("handleLogin:err = ",err.cod);
        alert("User credentials are wrong!");
      })
    }
  };

export const handleLogout = () => {
    return async (dispatch) => {
      //Now lets logout user
      fire
        .auth()
        .signOut()
        .then(() => {
            // console.log("Redux:actions:handleLogout:success");
            console.log("handleLogout:successful");
            dispatch(authListener());
        })
        .catch((err) => {
            // console.log("Redux:actions:handleLogout:err = ",err.cod);
            console.log("handleLogout:err = ",err.cod);
        });
    };
  };

  export const resetPasswordFunc = (email) => {
    return async (dispatch) => {
      fire
        .auth()
        .sendPasswordResetEmail(email)
        .then(() => {
          // console.log("Redux:actions:resetPasswordFunc:success");
          console.log("resetPasswordFunc:successful");
        })
        .catch((err) => {
          // console.log("Redux:actions:resetPasswordFunc:err = ",err.cod);
          console.log("resetPasswordFunc:err = ",err.cod);
        });
    };
  };

export const handleMessageUs = (user) => {
    // return async (dispatch) => {
    //   console.log("Redux:actions:handleMessageUs:user = ",user);
    //   fire
    //     .database()
    //     .ref("websiteMessageUs")
    //     .child(user.email)
    //     .set(user)
    //     .then((data) => {
    //       console.log("Redux:actions:handleMessageUs:success",data);
    //     })
    //     .catch((err) => {
    //       console.log("Redux:actions:handleMessageUs:err = ",err);
    //     });
    //   }
    return async (dispatch) => {
      // console.log("Redux:actions:handleMessageUs:user = ",user);
      fire
        .firestore()
        .collection("websiteMessageUs")
        .doc(user.email +"-"+ new Date().getTime())
        .set(user)
        .then((data) => {
          // console.log("Redux:actions:handleMessageUs:success = ",data);
          console.log("handleMessageUs:successful");
        })
        .catch((err) => {
          // console.log("Redux:actions:handleMessageUs:err = ",err);
          console.log("handleMessageUs:err = ",err);
        });
    };
  };

export const handleUserExist = (email) => {
  // console.log("Redux:actions:handleUserExist:email = ",email);
  return async (dispatch) => {
    // console.log("Redux:actions:handleUserExist:email2 = ",email);
    fire
    // .auth
    .getAuth()
    // .getUser(uid)
    .getUserByEmail(email)
    .then((userRecord) => {
      // See the UserRecord reference doc for the contents of userRecord.
      // console.log('Redux:actions:handleUserExist:Successfully fetched user data = ', userRecord.toJSON());
      // console.log('Redux:actions:handleUserExist: true');
    })
    .catch((error) => {
      // console.log('Redux:actions:handleUserExist:Error', error);
    });
  }
}

export  const updateAuthUser = (user) => {
  // console.log("Redux:actions:updateAuthUser:loggedInUser:data incoming = ",user);
  return async (dispatch) => {
    fire
      .firestore()
      .collection("userDetails")
      .doc(user.email)
      .set(user)
      .then((data) => {
        // console.log("Redux:actions:updateAuthUser:success = ",data);
        dispatch(handle_auth_user(user));
      })
      .catch((err) => {
        // console.log("Redux:actions:updateAuthUser:err = ",err);
      });
  };
};

export  const getAuthUser = (email, authenticatedUser) => {
  // console.log("Redux:actions:getAuthUser:loggedInUser:data incoming = ", email);
  return async (dispatch) => {
    const userRef = fire.firestore().collection('userDetails').doc(email);
    const doc = await userRef.get();
    if (!doc.exists) {
      // console.log('Redux:actions:getAuthUser:err = No such document!');
      dispatch(handle_auth_user(authenticatedUser))
    } else {
      // console.log('Redux:actions:getAuthUser:success = Document data:', doc.data());
      dispatch(handle_auth_user(doc.data()));
    }
  };
};

export const addToCart = (email, product) => {
  // console.log("Redux:actions:addToCart:loggedInUser:data incoming = ",product);
  return async (dispatch) => {
    // console.log("Redux:actions:addToCart:product = ",product);
    fire
      .firestore()
      .collection("cart")
      .doc(email)
      .set(product)
      .then((data) => {
        // console.log("Redux:actions:addToCart:success = ",data);
        // dispatch(getCartDetails(email));
      })
      .catch((err) => {
        // console.log("Redux:actions:addToCart:err = ",err);
      });
  };
};

export const removeFromCart = (email) => {
  // console.log("Redux:actions:removeFromCart");
  return async (dispatch) => {
    try{
      await fire.firestore().collection("cart").doc(email).delete();
      // console.log('Redux:actions:removeFromCart:Success!');
      // update your state or anything you want to do after remove
      dispatch(handle_Clear_Cart())
    }
    catch(error){
      // console.log('Redux:actions:removeFromCart:error:', error);
    }
  };
};

function addMonths(date, months) {
  var d = date.getDate();
  date.setMonth(date.getMonth() + months);
  if (date.getDate() != d) {
    date.setDate(0);
  }
  date.setDate(date.getDate() - 1); // Substracting 1 day to the date
  return date;
} 

function returnEndDate(months) {
  const FromDate = new Date();
  const endDate = addMonths(FromDate,parseInt(months));
  // console.log("Redux:actions:returnEndDate: endDate = ", endDate);
  return returnDate(endDate);
}

function returnDueDate(noOfDays) {
  var myCurrentDate=new Date();
  var myFutureDate=new Date(myCurrentDate);
  myFutureDate.setDate(myFutureDate.getDate() + noOfDays);
  return returnDate(myFutureDate);
}

function returnDate(date) {
  var dd = date.getDate();
  var mm = date.getMonth() + 1;
  var yyyy = date.getFullYear();
  if (dd < 10) {
      dd = '0' + dd;
  }
  if (mm < 10) {
      mm = '0' + mm;
  }
  return dd + '-' + mm + '-' + yyyy;
}

export const getCartDetails = (email) => {
  // console.log("Redux:actions:getCartDetails");
  return async (dispatch) => {
    const userRef = fire.firestore().collection('cart').doc(email);
    const doc = await userRef.get();
    if (!doc.exists) {
      // console.log('Redux:actions:getCartDetails:err = No such document!');
    } else {
      const cartDetails = doc.data();
      // console.log('Redux:actions:getCartDetails:success = Document data:', cartDetails);
      // dispatch(handle_auth_user(doc.data()));
      dispatch(handle_product_details(cartDetails));
      const endDate = returnEndDate(cartDetails.Hi.month);
      dispatch(handle_endDate(endDate));
    }
  };
};

export const handleProductDetails = (email,productDetails,newProduct) => {
  // console.log("Redux:actions:handleProductDetails:productDetails,newProduct = ",productDetails,newProduct);
  return async (dispatch) => {
    // Removing the specified element by value from the array
    var spliced = [];
    if (Object.keys(productDetails).length > 0) {
    // if (productDetails.length > 0) {
      // for (var i = 0; i < productDetails.length; i++) {
      //   if (productDetails[i].name === newProduct.name) {
      //     spliced = [productDetails.splice(i, 1)];
      //     console.log("Redux:actions:handleProductDetails:spliced = ",spliced);
      //     break;
      //   }
      // }
      // var productDetails2 = [...productDetails,newProduct];
      var productDetails2 = {...productDetails,...newProduct};
      dispatch(handle_product_details(productDetails2));
    } else {
      // var productDetails2 = [newProduct];
      var productDetails2 = newProduct;
      dispatch(handle_product_details(productDetails2));
    }
    // var gTotal = 0;
    // for (var i = 0; i < state.productDetails.length; i++) {
    //   gTotal = gTotal + state.productDetails[i].total;
    // }
    // state.productDetails.grandTotal = gTotal;
    // state.productDetails.amountPayable = gTotal + ((gTotal / 100) * 18);
    // console.log("Redux:actions:handleProductDetails:productDetails = ",state.productDetails);

    // addToCart(email, productDetails2)
    dispatch(addToCart(email, productDetails2));
  }
}

function generatePassword() {
  var chars = "0123456789abcdefghijklmnopqrstuvwxyz!@#$%^&*()ABCDEFGHIJKLMNOPQRSTUVWXYZ";
  var passwordLength = 12;
  var password = "";
  for (var i = 0; i <= passwordLength; i++) {
    var randomNumber = Math.floor(Math.random() * chars.length);
    password += chars.substring(randomNumber, randomNumber +1);
  }
  // console.log("Redux:actions:generatePassword: new password = ",password);
  return password;
}

function sendEmail(isAuthenticated, user, invoice, subscription) {
  // console.log("Redux:actions:sendEmail:isAuthenticated, user, invoice, subscription = ",isAuthenticated, user, invoice, subscription);
    // var serviceID = process.env.EMAILJS_SERVICE_ID; 
    // var templateID_UN = process.env.EMAILJS_TEMPLATE_ID_USERNAME;
    // var templateID_PWD = process.env.EMAILJS_TEMPLATE_ID_PASSWORD;
    // var publicKey = process.env.EMAILJS_PUBLIC_KEY;

    // lohith 
    var serviceID = "service_pqjylgh"; 
    var templateID_UN = "template_fkkvz6m";
    var templateID_PWD = "template_wn1t20o";
    var publicKey = "-amz6QBDd8hRF9x-H";

    var templateParams = {
      to_name : user.fullName ? user.fullName : user.name,
      from_name : "aiRender Technology",
      to_email : user.email,
      from_email : "airender.airender@gmail.com",
    }
    
    var templateParamsUN = {
      ...templateParams,
      userName: isAuthenticated ? user.fullName : subscription.userName,
      from_date : invoice.from_date,
      to_date : invoice.to_date,
      month: invoice.items[0].month,
    }; 
    var templateParamsPWD = {
      ...templateParams,
      password: subscription.password,
    };
    // console.log("Redux:actions:sendEmail:Email data = ",serviceID, templateID_UN, templateParamsUN, templateID_PWD, templateParamsPWD, publicKey);

    if(isAuthenticated) {
      emailjs
      .send(serviceID, templateID_UN, templateParamsUN, publicKey)
      .then(
        (result) => {
          // console.log("Redux:actions:sendEmail:userName:emailJS", result.text);
        },
        (error) => {
          // console.log("Redux:actions:sendEmail:userName:emailJS", error.text);
        }
      );
    } else {
      emailjs
      .send(serviceID, templateID_UN, templateParamsUN, publicKey)
      .then(
        (result) => {
          // console.log("Redux:actions:sendEmail:userName:emailJS", result.text);

          emailjs
          .send(serviceID, templateID_PWD, templateParamsPWD, publicKey)
          .then(
            (result) => {
              // console.log("Redux:actions:sendEmail:password:emailJS", result.text);
            },
            (error) => {
              // console.log("Redux:actions:sendEmail:password:emailJS", error.text);
            }
          );
        },
        (error) => {
          // console.log("Redux:actions:sendEmail:userName:emailJS", error.text);
        }
      );
    }
}

export const updateBillNumber = (billType, latestBillNo) => {  // billType = receipt or invoice
  // console.log("Redux:actions:updateBillNumber : billType, latestBillNo =", billType, latestBillNo);
  return async (dispatch) => {
    // console.log("Redux:actions:updateBillNumber : billType, latestBillNo 2=", billType, latestBillNo);
    var newBillNumber = {
      new: latestBillNo + 1,
    }
    // console.log("Redux:actions:updateBillNumber : newBillNumber =", newBillNumber);
    fire
    .firestore()
    .collection("billNumber")
    .doc(billType)
    .set(newBillNumber)
    .then((data) => {
      // console.log("Redux:actions:updateBillNumber:success = ",data);
    })
    .catch((err) => {
      // console.log("Redux:actions:updateBillNumber:err = ",err);
    });
  };
}

export const getBillNumber = (billType) => {  // billType = receipt or invoice
  // console.log("Redux:actions:getBillNumber");
  return async (dispatch) => {
    const userRef = fire.firestore().collection("billNumber").doc(billType);
    // const doc = await userRef.get();
    // if (!doc.exists) {
    //   console.log('Redux:actions:getBillNumber:err = No such document!');
    // } else {
    //   console.log('Redux:actions:getBillNumber:success = Document data:', doc.data());
    // }
    userRef.onSnapshot((doc) => {
      // console.log('Redux:actions:getBillNumber:success = Document data:', doc.data());
      dispatch(handle_billNumber(doc.data().new));
      // updateBillNumber(billType, doc.data().new);
    })
    .then((data) => {
      // console.log('Redux:actions:getBillNumber:success:data =', data);
    })
    .catch((err) => {
      // console.log('Redux:actions:getBillNumber:err = ', err);
    })
  };
}

export const addSubscription = (isAuthenticated, user, invoice, productName) => {
  // console.log("Redux:actions:addSubscription:loggedInUser:data incoming = ",user,invoice);
  var emailStrings = user.email ? user.email.split("@") : "";
  var userName = emailStrings[0];
  var domainName = emailStrings[1];
  var newPassword = generatePassword();
  var subscription = {
    // id : invoice.id,
    // product : invoice.items[0].name,
    [productName]:{
      invoice_no : invoice.invoice_no,
      trans_date : invoice.trans_date,
      from_date : invoice.from_date,
      to_date : invoice.to_date,
      due_date : invoice.due_date,
      userName : userName,
      password : newPassword,
    }
  }
  // console.log("Redux:actions:addSubscription:subscription = ",subscription);
  return async (dispatch) => {
    dispatch(getCartDetails(user.email));
    // const endDate = returnEndDate(invoice.items[0].month);
    // dispatch(handle_endDate(endDate));
    // console.log("Redux:actions:addSubscription:subscription = ",subscription);
    // handleUserExist(user.email);    
    sendEmail(isAuthenticated, user, invoice, subscription)
    fire
      .firestore()
      .collection("subscription")
      .doc(user.email)
      .set(subscription)
      .then((data) => {
        // console.log("Redux:actions:addSubscription:success = ",data);
        dispatch(removeFromCart(user.email))
      })
      .catch((err) => {
        // console.log("Redux:actions:addSubscription:err = ",err);
      });
  };
};

export const getSubscriptionDetails = (email) => {
  // console.log("Redux:actions:getSubscriptionDetails");
  return async (dispatch) => {
    const userRef = fire.firestore().collection("subscription").doc(email);
    const doc = await userRef.get();
    if (!doc.exists) {
      // console.log('Redux:actions:getSubscriptionDetails:err = No such document!');
    } else {
      // console.log('Redux:actions:getSubscriptionDetails:success = Document data:', doc.data());
      dispatch(handle_subscriptions(doc.data()));
    }
  };
};

export const deleteSubscription = (email) => {
  // console.log("Redux:actions:deleteSubscription");
  return async (dispatch) => {
    try{
      await fire.firestore().collection("subscription").doc(email).delete();
      // console.log('Redux:actions:deleteSubscription:Success!');
      // update your state or anything you want to do after deletion
    }
    catch(error){
      // console.log('Redux:actions:deleteSubscription:error:', error);
    }
  };
};

export const get3DRecords = (uid) => {
  console.log("Redux:actions:get3DRecords: uid = ",uid);
  return async (dispatch) => {
    console.log("Redux:actions:get3DRecords:inside");
    const userRef = fire.firestore().collection('3D_Queue').doc(uid);
    userRef.onSnapshot((snapshot) => {
      console.log("Redux:actions:get3DRecords:snapshot = ",snapshot.data());
      //snapshot.forEach(doc => {
      //  console.log(doc.id, '=>', doc.data());
        dispatch(handle_3DRecords(snapshot.data()));
      //})
    }, (error) => {
      //...
    });
  };
};

export const delete3DRecord = (uid) => {
  // console.log("Redux:actions:delete3DRecord");
  return async (dispatch) => {
    try{
      await fire.firestore().collection("3D_Queue").doc(uid).delete();
      // console.log('Redux:actions:delete3DRecord:Success!');
      // update your state or anything you want to do after deletion
    }
    catch(error){
      // console.log('Redux:actions:delete3DRecord:error:', error);
    }
  };
};


// export const startRecording = () => {
//   // recordedBlobs = [];
//   let options = {mimeType: 'video/webm;codecs=vp9,opus'};
//   return async () => {
//   try {
//     let newMediaRecorder = new MediaRecorder(window.stream, options);
//     dispatch(handle_mediaRecorder(newMediaRecorder));

    
//   } catch (e) {
//     console.error('Exception while creating MediaRecorder:', e);
//   } finally {

//       mediaRecorder.onstop = (event) => {
//           console.log('Recorder stopped: ', event);
//           console.log('Recorded Blobs: ', recordedBlobs);          
//           setPlaying(false);
//       };
//       mediaRecorder.ondataavailable = handleDataAvailable;
//       mediaRecorder.start();

//       setPlaying(true);
//       setUploadOrDownloadCount(0);
//       setWebCamRecordStart(true)

//       console.log('startRecording:MediaRecorder started', mediaRecorder);
//   }
// }

  // console.log('Created MediaRecorder', mediaRecorder,mediaRecorder.state, 'with options', options);
  // if(mediaRecorder.state == "recording"){
  //     mediaRecorder.onstop = (event) => {
  //         console.log('Recorder stopped: ', event);
  //         console.log('Recorded Blobs: ', recordedBlobs);          
  //         setPlaying(false);
  //       };
  //     mediaRecorder.ondataavailable = handleDataAvailable;
  // } else {
  //     mediaRecorder.ondataavailable = handleDataAvailable;
  //     mediaRecorder.start();
  // }
  

// }

// export function startRoomRecording() {
//   return function (dispatch, getState) {
//     var feeds1 = getState().videoRoom.feeds;

//     var localFeed = feeds1.filter(function (feed) {
//       return !feed.remote;
//     });
//     var videoRoomLocal = null;
//     var localFeedId = null;
//     if (localFeed) {
//       if (localFeed[0]) {
//         videoRoomLocal = localFeed[0].plugin;
//         localFeedId = localFeed[0].id;
//       }
//     }

//     var janusConfig = getState().janusConfig.config;
//     var room = janusConfig.room.room;
//     var secret = janusConfig.room.secret;

//     // Publish our stream
//     return new Promise(function (resolve, reject) {
//       if (videoRoomLocal) {
//         var record_start = {
//           request: "enable_recording",
//           room: room,
//           secret: secret,
//           record: true,
//           fetch_recording: false,
//           record_requester: localFeedId,
//         };
//         videoRoomLocal.send({
//           message: record_start,
//           success: function success(msg) {
//             var record = msg.record;
//             var already_recording = msg.already_recording;
//             var recording_time = msg.recording_time;

//             if (record) {
//               dispatch({
//                 type: ALREADY_RECORDING,
//                 recordRequest: record,
//                 alreadyRecording: already_recording,
//                 recordingStartTime: recording_time,
//               });
//             }
//             resolve(); //is this required?
//           },
//           error: function (message) {
//             reject(); //is this required?
//           },
//         });
//       }
//     });
//   };
// }
